import { useEffect } from "react";
import { validateAuthenticationState } from "../redux/actions/Auth";

const useCheckAuthStateInterval = (dispatch, interval) => {
  useEffect(() => {
    if (!interval) return undefined;

    const intervalId = setInterval(() => {
      validateAuthenticationState(dispatch, {
        fromStateListener: false,
        user: null,
      });
    }, interval);

    return () => clearInterval(intervalId); // Clean up on unmount
  }, [interval]);
};

export default useCheckAuthStateInterval;
